<template>
  <v-app class="saga-app">
    <v-app-bar color="black" dense dark>
      <router-link to="/">
        <v-img
          class="mx-2"
          src="https://firebasestorage.googleapis.com/v0/b/vuesaga-b8d1b.appspot.com/o/icons%2Fsaga-logo.png?alt=media&token=d39b7215-7c83-4a92-8c31-10c700ec372c"
          max-height="40"
          max-width="40"
          contain
          to="/"
        ></v-img>
      </router-link>
      <v-toolbar-title>
        <router-link to="/" class="logo-text-link">{{ appTitle }}</router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn text to="/">
        <v-icon>mdi-home-outline</v-icon>
        Home
      </v-btn>
      <!-- <v-btn text to="/support">
        <v-icon>mdi-face-agent</v-icon>
        Support
      </v-btn>
      <v-btn text to="/faq">
        <v-icon>mdi-help-circle-outline</v-icon>
        FAQs
      </v-btn> -->
      <!-- <div v-if="isUserLoggedIn">
        <v-btn text to="/account">
          <v-icon>mdi-account-outline</v-icon>
          Account
        </v-btn>
        <v-btn text @click="logout">
          <v-icon>mdi-lock-outline</v-icon>
          Logout
        </v-btn>
      </div>
      <div v-else>
        <Login />
          Logged out
      </div> -->
      <!-- <router-link to="/about" class="top-nav-link">About</router-link> -->
      <language-switcher />
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
    <v-footer dark padless>
      <v-card
        flat
        tile
        class="blue-grey darken-4 white--text text-center full-width"
      >
        <v-card-text>
          <v-btn
            class="mx-4 white--text"
            icon
            href="https://www.facebook.com/sagaDashboard"
            target="_blank"
          >
            <v-icon size="24px">mdi-facebook</v-icon>
          </v-btn>
          <v-btn
            class="mx-4 white--text"
            icon
            href="https://twitter.com/SagaDashboard"
            target="_blank"
          >
            <v-icon size="24px">mdi-twitter</v-icon>
          </v-btn>
        </v-card-text>

        <v-card-text class="white--text pt-0">
          <p>{{ $t('footer.par1') }}</p>
          <p>{{ $t('footer.par2') }}</p>
          <p>
            <router-link to="/about" class="footer-text-link">
              About Us
            </router-link>
            |
            <router-link to="/terms" class="footer-text-link">
              {{ $t('common.terms') }}
            </router-link>
            |
            <router-link to="/privacy" class="footer-text-link">
              {{ $t('common.privacy') }}
            </router-link>
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text">
          &copy; {{ new Date().getFullYear() }} — Saga Dashboard
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import firebase from '@firebase/app'
import '@firebase/auth'
import { mapState, mapGetters } from 'vuex'
import LanguageSwitcher from './components/LanguageSwitcher/LanguageSwitcher'
// import Login from './auth/Login'

export default {
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      appTitle: 'Saga Dashboard',
      icons: ['mdi-facebook', 'mdi-twitter', 'mdi-linkedin', 'mdi-instagram']
    }
  },
  computed: {
    ...mapGetters('authentication', ['isUserLoggedIn']),
    ...mapState('authentication', ['user']),
    ...mapState('dashboard', ['dashboard']),
    ...mapState('settings', ['settings'])
  },
  methods: {
    async logout() {
      this.$router.push('/')
      await firebase.auth().signOut()
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Amatic+SC:wght@400;700&display=swap');
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #c9c9c9 !important;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #fff;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.logo-text-link {
  font-family: 'Amatic SC', cursive;
  color: white !important;
  font-size: 32px;
  text-decoration: none;
}
.footer-text-link {
  color: white !important;
  text-decoration: none;
}
.top-nav-link {
  color: white !important;
  text-decoration: none;
}
.full-width {
  width: 100%;
}
</style>
